'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is the default Northam fallback sales number. NOT Invoca
var initialState = {
  'sales-footer': '1 857 829 5060',
  'sales-middle': '1 857 829 5060',
  'crm-middle': '1 857 829 5060',
  'marketing-footer': '1 857 829 5060',
  'marketing-middle': '1 857 829 5060',
  'service-footer': '1 857 829 5060',
  'service-middle': '1 857 829 5060',
  'growthsuite-middle': '1 857 829 5060',
  'growthsuite-footer': '1 857 829 5060',
  'cms-footer': '1 857 829 5060',
  'cms-middle': '1 857 829 5060',
  bundle: '1 857 829 5060'
};

var PhoneNumbers = function PhoneNumbers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.PHONE_NUMBERS_RECEIVED:
      return payload.phoneNumbers;
    default:
      return state;
  }
};

exports.default = PhoneNumbers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/PhoneNumbers.js
// module id = 395
// module chunks = 3 4 5